// extracted by mini-css-extract-plugin
export default {"username":"navbar_username__Gugj9"};